import Highway from '@dogstudio/highway';

class CustomRenderer extends Highway.Renderer {
    // Hooks/methods
    onEnter() {
        console.log('test on enter')
    }
    onLeave() {
        console.log('test on leave')
    }
    onEnterCompleted() {
        console.log('test on enter completed')
    }
    onLeaveCompleted() {
        console.log('test on leave completed')
    }
}

// Don`t forget to export your renderer
export default CustomRenderer;